// GENERATED by scripts/build-icons.mjs from icons/chevron-down.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ChevronDown = createIcon('chevron-down', [
  ['path', { d: "m6 9 6 6 6-6" }],
])
